<template>
    <div class="feishu-container">
        <div class="cards-row">
        <!-- 飞书应用配置 -->
        <el-card class="config-card">
            <div slot="header" class="clearfix">
                <span class="title">飞书应用配置</span>
                <el-button
                    style="float: right;"
                    type="primary"
                    size="small"
                    :loading="loadingSave"
                    @click="saveConfigBtn"
                    icon="el-icon-finished">保存配置</el-button>
                <el-button
                    style="float: right; margin-right: 10px;"
                    type="warning"
                    size="small"
                    :loading="loadingTest"
                    @click="testConnectionBtn"
                    icon="el-icon-connection">测试连接</el-button>
            </div>
            <el-form ref="configForm" :model="config" label-width="150px">
                <el-form-item label="应用名称：">
                    <el-input v-model="config.name" placeholder="如：广告系统"></el-input>
                </el-form-item>
                <el-form-item label="App ID：">
                    <el-input v-model="config.app_id" placeholder="飞书开放平台应用 App ID"></el-input>
                </el-form-item>
                <el-form-item label="App Secret：">
                    <el-input v-model="config.app_secret" type="password" show-password placeholder="填写新值以更新，留空则保持不变"></el-input>
                </el-form-item>
                <el-form-item label="文件夹 Token：">
                    <el-input v-model="config.folder_token" placeholder="可选，多维表格所属文件夹 token"></el-input>
                </el-form-item>
                <el-form-item label="默认表名：">
                    <el-input v-model="config.default_name" placeholder="创建多维表格时的默认名称"></el-input>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 创建多维表格 -->
        <el-card class="bitable-card">
            <div slot="header" class="clearfix">
                <span class="title">创建多维表格</span>
                <el-button
                    style="float: right;"
                    type="primary"
                    size="small"
                    :loading="loadingCreate"
                    @click="createBitableBtn"
                    icon="el-icon-plus">创建多维表格</el-button>
            </div>
            <el-form ref="bitableForm" :model="bitable" label-width="150px">
                <el-form-item label="表格名称：">
                    <el-input v-model="bitable.name" :placeholder="config.default_name || '广告投放数据表'"></el-input>
                </el-form-item>
                <el-form-item label="文件夹 Token：">
                    <el-input v-model="bitable.folder_token" :placeholder="config.folder_token || '不填则使用应用配置'"></el-input>
                </el-form-item>
                <el-form-item label="时区：">
                    <el-input v-model="bitable.time_zone" placeholder="如 Asia/Shanghai"></el-input>
                </el-form-item>
                <el-form-item label="自定义字段：">
                    <div class="fields-wrap">
                        <div v-for="(field, index) in bitable.fields" :key="index" class="field-row">
                            <el-input v-model="field.field_name" placeholder="字段名称" class="field-name"></el-input>
                            <el-select v-model="field.type" placeholder="字段类型" class="field-type">
                                <el-option v-for="item in fieldTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeField(index)"></el-button>
                        </div>
                        <el-button type="text" icon="el-icon-plus" @click="addField">添加字段</el-button>
                        <div v-if="bitableResult" class="bitable-result">
                            <p class="result-title">创建成功：</p>
                            <p>表格名称：<span class="value">{{ bitableResult.name }}</span></p>
                            <p>
                                app_token：
                                <span class="value" @click="copy(bitableResult.app_token)">{{ bitableResult.app_token }}</span>
                                <el-button type="text" size="mini" @click="copy(bitableResult.app_token)">复制</el-button>
                            </p>
                            <p>
                                default_table_id：
                                <span class="value" @click="copy(bitableResult.default_table_id)">{{ bitableResult.default_table_id }}</span>
                                <el-button type="text" size="mini" @click="copy(bitableResult.default_table_id)">复制</el-button>
                            </p>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </el-card>
        </div>

        <!-- 新增数据表 + 新增多条记录 -->
        <div class="cards-row second-row">
        <!-- 新增数据表 -->
        <el-card class="table-card">
            <div slot="header" class="clearfix">
                <span class="title">新增数据表</span>
                <el-button
                    style="float: right;"
                    type="success"
                    size="small"
                    :loading="loadingTable"
                    @click="createTableBtn"
                    icon="el-icon-plus">新增数据表</el-button>
            </div>
            <el-form ref="tableForm" :model="table" label-width="150px">
                <el-form-item label="App Token：">
                    <el-input v-model="table.app_token" :placeholder="bitableResult ? bitableResult.app_token : '多维表格 app_token，创建多维表格后自动填入'"></el-input>
                </el-form-item>
                <el-form-item label="表名称：">
                    <el-input v-model="table.name" :placeholder="config.default_name || '数据表名称'"></el-input>
                </el-form-item>
                <el-form-item label="默认视图名：">
                    <el-input v-model="table.default_view_name" placeholder="可选，如 表格视图"></el-input>
                </el-form-item>
                <el-form-item label="自定义字段：">
                    <div class="fields-wrap">
                        <div v-for="(field, index) in table.fields" :key="index" class="field-row">
                            <el-input v-model="field.field_name" placeholder="字段名称" class="field-name"></el-input>
                            <el-select v-model="field.type" placeholder="字段类型" class="field-type">
                                <el-option v-for="item in fieldTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="removeTableField(index)"></el-button>
                        </div>
                        <el-button type="text" icon="el-icon-document-copy" @click="copyTableFieldsToJson">复制为 JSON</el-button>
                        <el-button type="text" icon="el-icon-plus" @click="addTableField">添加字段</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="初始记录（JSON，可选）：">
                    <el-input
                        type="textarea"
                        :rows="5"
                        v-model="table.recordsContent"
                        placeholder='可选，创建数据表时同时写入记录。[{"fields":{"字段A":"值1"}}]'></el-input>
                </el-form-item>
                <div v-if="tableResult" class="bitable-result">
                    <p class="result-title">新增结果：</p>
                    <p>表 ID（table_id）：<span class="value">{{ tableResult.table_id }}</span></p>
                    <p v-if="tableResult.default_view_id">默认视图 ID：<span class="value">{{ tableResult.default_view_id }}</span></p>
                </div>
            </el-form>
        </el-card>

        <!-- 新增多条记录 -->
        <el-card class="records-card">
            <div slot="header" class="clearfix">
                <span class="title">新增多条记录</span>
                <el-button
                    style="float: right;"
                    type="primary"
                    size="small"
                    :loading="loadingRecord"
                    @click="batchCreateRecordsBtn"
                    icon="el-icon-finished">新增记录</el-button>
            </div>
            <el-form ref="recordsForm" :model="records" label-width="150px">
                <el-form-item label="App Token：">
                    <el-input v-model="records.app_token" :placeholder="bitableResult ? bitableResult.app_token : '多维表格 app_token，创建多维表格后自动填入'"></el-input>
                </el-form-item>
                <el-form-item label="表 ID（table_id）：">
                    <el-input v-model="records.table_id" :placeholder="bitableResult ? bitableResult.default_table_id : '多维表格默认表 ID，创建多维表格后自动填入'"></el-input>
                </el-form-item>
                <el-form-item label="记录数据（JSON）：">
                    <el-input
                        type="textarea"
                        :rows="10"
                        v-model="records.content"
                        placeholder='JSON 数组，每条记录一个对象，字段名需与表头一致。示例：[{"fields":{"订单号":"A001","金额":100}}]'></el-input>
                    <el-button type="text" icon="el-icon-plus" @click="insertRecordExample">填入示例</el-button>
                    <div v-if="recordResult" class="bitable-result">
                        <p class="result-title">新增结果：</p>
                        <p>成功条数：<span class="value">{{ recordResult.success_count !== undefined ? recordResult.success_count : (Array.isArray(recordResult.records) ? recordResult.records.length : 0) }}</span></p>
                        <p v-if="recordResult.failed_count && recordResult.failed_count > 0">失败条数：<span class="value">{{ recordResult.failed_count }}</span></p>
                    </div>
                </el-form-item>
            </el-form>
        </el-card>
        </div>

        <!-- 删除多个数据表 -->
        <div class="cards-row third-row">
            <el-card class="delete-card">
                <div slot="header" class="clearfix">
                    <span class="title">删除多个数据表</span>
                    <el-button
                        style="float: right;"
                        type="danger"
                        size="small"
                        :loading="loadingDelete"
                        @click="batchDeleteTablesBtn"
                        icon="el-icon-delete">删除数据表</el-button>
                </div>
                <el-form ref="deleteForm" :model="deleteTables" label-width="150px">
                    <el-form-item label="App Token：">
                        <el-input v-model="deleteTables.app_token" :placeholder="bitableResult ? bitableResult.app_token : '多维表格 app_token，创建多维表格后自动填入'"></el-input>
                    </el-form-item>
                    <el-form-item label="表 ID（table_id）：">
                        <el-input
                            type="textarea"
                            :rows="6"
                            v-model="deleteTables.table_ids_text"
                            placeholder="每行一个表 ID，可一次删除多个数据表。例如：&#10;tblAxxx&#10;tblBxxx"></el-input>
                    </el-form-item>
                    <div v-if="deleteResult" class="bitable-result">
                        <p class="result-title">删除结果：</p>
                        <p>删除数量：<span class="value">{{ deleteResult.deleted_count !== undefined ? deleteResult.deleted_count : 0 }}</span></p>
                    </div>
                </el-form>
            </el-card>

            <!-- 删除多条记录 -->
            <el-card class="delete-record-card">
                <div slot="header" class="clearfix">
                    <span class="title">删除多条记录</span>
                    <el-button
                        style="float: right;"
                        type="danger"
                        size="small"
                        :loading="loadingDeleteRecord"
                        @click="batchDeleteRecordsBtn"
                        icon="el-icon-delete">删除记录</el-button>
                </div>
                <el-form ref="deleteRecordForm" :model="deleteRecords" label-width="150px">
                    <el-form-item label="App Token：">
                        <el-input v-model="deleteRecords.app_token" :placeholder="bitableResult ? bitableResult.app_token : '多维表格 app_token，创建多维表格后自动填入'"></el-input>
                    </el-form-item>
                    <el-form-item label="表 ID（table_id）：">
                        <el-input v-model="deleteRecords.table_id" :placeholder="bitableResult ? bitableResult.default_table_id : '多维表格默认表 ID，创建多维表格后自动填入'"></el-input>
                    </el-form-item>
                    <el-form-item label="记录 ID（record_id）：">
                        <el-input
                            type="textarea"
                            :rows="6"
                            v-model="deleteRecords.records_text"
                            placeholder="每行一个记录 ID，可一次删除多条。例如：&#10;recAxxx&#10;recBxxx"></el-input>
                    </el-form-item>
                    <div v-if="deleteRecordResult" class="bitable-result">
                        <p class="result-title">删除结果：</p>
                        <p>删除数量：<span class="value">{{ deleteRecordResult.deleted_count !== undefined ? deleteRecordResult.deleted_count : 0 }}</span></p>
                    </div>
                </el-form>
            </el-card>
        </div>

        <!-- 列出数据表 -->
        <div class="cards-row fourth-row">
            <el-card class="list-card">
                <div slot="header" class="clearfix">
                    <span class="title">列出数据表</span>
                    <el-button
                        style="float: right;"
                        type="primary"
                        size="small"
                        :loading="loadingList"
                        @click="listTablesBtn"
                        icon="el-icon-search">查询</el-button>
                </div>
                <el-form ref="listForm" :model="listTables" label-width="150px">
                    <el-form-item label="App Token：">
                        <el-input v-model="listTables.app_token" :placeholder="bitableResult ? bitableResult.app_token : '多维表格 app_token，创建多维表格后自动填入'"></el-input>
                    </el-form-item>
                </el-form>
                <div v-if="tableList && tableList.length" class="bitable-result">
                    <p class="result-title">查询结果（共 {{ tableTotal }} 个数据表，点击行可查询该表字段）：</p>
                    <el-table :data="tableList" size="small" border style="width: 100%"
                              :row-style="{cursor: 'pointer'}" @row-click="handleTableRowClick">
                        <el-table-column prop="table_id" label="table_id" min-width="180" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="name" label="表名称" min-width="160"></el-table-column>
                        <el-table-column prop="default_view_id" label="默认视图 ID" min-width="180" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
            </el-card>

            <!-- 更新数据表 -->
            <el-card class="update-card">
                <div slot="header" class="clearfix">
                    <span class="title">更新数据表</span>
                    <el-button
                        style="float: right;"
                        type="primary"
                        size="small"
                        :loading="loadingUpdate"
                        @click="updateTableBtn"
                        icon="el-icon-edit">更新数据表</el-button>
                </div>
                <el-form ref="updateForm" :model="updateTable" label-width="150px">
                    <el-form-item label="App Token：">
                        <el-input v-model="updateTable.app_token" :placeholder="bitableResult ? bitableResult.app_token : '多维表格 app_token，创建多维表格后自动填入'"></el-input>
                    </el-form-item>
                    <el-form-item label="表 ID（table_id）：">
                        <el-input v-model="updateTable.table_id" placeholder="要更新的数据表 table_id，可用“列出数据表”查询"></el-input>
                    </el-form-item>
                    <el-form-item label="新的表名称：">
                        <el-input v-model="updateTable.name" placeholder="修改后的数据表名称"></el-input>
                    </el-form-item>
                </el-form>
                <div v-if="updateResult" class="bitable-result">
                    <p class="result-title">更新结果：</p>
                    <p>表名称：<span class="value">{{ updateResult.name }}</span></p>
                    <p>table_id：<span class="value">{{ updateResult.table_id }}</span></p>
                </div>
            </el-card>
        </div>

        <!-- 列出字段 -->
        <div class="cards-row fifth-row">
            <el-card ref="fieldCard" class="field-card">
                <div slot="header" class="clearfix">
                    <span class="title">列出字段</span>
                    <el-button
                        style="float: right;"
                        type="primary"
                        size="small"
                        :loading="loadingFields"
                        @click="listFieldsBtn"
                        icon="el-icon-search">查询</el-button>
                    <el-button
                        style="float: right; margin-right: 8px;"
                        type="primary"
                        size="small"
                        plain
                        icon="el-icon-plus"
                        @click="openCreateFieldDialog">新增字段</el-button>
                </div>
                <el-form ref="fieldForm" :model="listFields" label-width="150px">
                    <el-form-item label="App Token：">
                        <el-input v-model="listFields.app_token" :placeholder="bitableResult ? bitableResult.app_token : '多维表格 app_token，创建多维表格后自动填入'"></el-input>
                    </el-form-item>
                    <el-form-item label="表 ID（table_id）：">
                        <el-input v-model="listFields.table_id" placeholder="要查询字段的数据表 table_id，可用「列出数据表」查询"></el-input>
                    </el-form-item>
                </el-form>
                <div v-if="fieldList && fieldList.length" class="bitable-result">
                    <p class="result-title">查询结果（共 {{ fieldTotal }} 个字段）：</p>
                    <el-table :data="fieldList" size="small" border style="width: 100%">
                        <el-table-column prop="field_name" label="字段名称" min-width="140"></el-table-column>
                        <el-table-column prop="field_id" label="field_id" min-width="170" show-overflow-tooltip></el-table-column>
                        <el-table-column label="类型" min-width="110">
                            <template slot-scope="scope">{{ fieldTypeLabel(scope.row.type) }}</template>
                        </el-table-column>
                        <el-table-column prop="ui_type" label="ui_type" min-width="110"></el-table-column>
                        <el-table-column label="主键" width="70" align="center">
                            <template slot-scope="scope">{{ scope.row.is_primary ? '是' : '' }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="160" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" style="color:#409EFF" @click="openUpdateFieldDialog(scope.row)">更新字段</el-button>
                                <el-button type="text" style="color:#F56C6C" @click="deleteFieldBtn(scope.row)">删除字段</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
        </div>

        <!-- 新增字段 -->
        <el-dialog title="新增字段（列出字段）" :visible.sync="createFieldVisible" width="620px"
                   :close-on-click-modal="false" append-to-body>
            <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
                在指定多维表格数据表内新增一个字段，创建成功后会刷新「列出字段」的查询结果。
            </div>
            <el-form :model="createFieldForm" label-width="120px" label-position="right">
                <el-form-item label="App Token">
                    <el-input v-model="createFieldForm.app_token" placeholder="bascxxxxxxxxxx（必填）" clearable/>
                </el-form-item>
                <el-form-item label="表 ID">
                    <el-input v-model="createFieldForm.table_id" placeholder="tblxxxxxxxxxx（必填）" clearable/>
                </el-form-item>
                <el-form-item label="字段名称">
                    <el-input v-model="createFieldForm.field_name" placeholder="字段名称，如：订单金额" clearable/>
                </el-form-item>
                <el-form-item label="字段类型">
                    <el-select v-model="createFieldForm.type" style="width: 100%">
                        <el-option v-for="opt in fieldTypes" :key="opt.value" :label="opt.label" :value="opt.value"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="ui_type">
                    <el-input v-model="createFieldForm.ui_type" placeholder="可选，如 Text / Number / SingleSelect" clearable/>
                </el-form-item>
                <el-form-item label="字段属性">
                    <el-input v-model="createFieldForm.property" type="textarea" :rows="3"
                              placeholder='可选，JSON 对象，如 {"formatter":"0"} 或 {"options":[{"name":"选项1"}]}'/>
                </el-form-item>
                <el-form-item label="字段描述">
                    <el-input v-model="createFieldForm.description" placeholder="可选，字段描述" clearable/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="createFieldVisible = false">取 消</el-button>
                <el-button type="primary" :loading="createFieldLoading" @click="handleCreateField">新增字段</el-button>
            </span>
        </el-dialog>

        <!-- 更新字段 -->
        <el-dialog title="更新字段（列出字段）" :visible.sync="updateFieldVisible" width="620px"
                   :close-on-click-modal="false" append-to-body>
            <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
                更新指定字段的名称/类型/属性，更新成功后会刷新「列出字段」的查询结果。
            </div>
            <el-form :model="updateFieldForm" label-width="120px" label-position="right">
                <el-form-item label="字段 ID">
                    <el-input v-model="updateFieldForm.field_id" disabled/>
                </el-form-item>
                <el-form-item label="字段名称">
                    <el-input v-model="updateFieldForm.field_name" placeholder="新的字段名称" clearable/>
                </el-form-item>
                <el-form-item label="字段类型">
                    <el-select v-model="updateFieldForm.type" style="width: 100%">
                        <el-option v-for="opt in fieldTypes" :key="opt.value" :label="opt.label" :value="opt.value"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="ui_type">
                    <el-input v-model="updateFieldForm.ui_type" placeholder="可选，如 Text / Number / SingleSelect" clearable/>
                </el-form-item>
                <el-form-item label="字段属性">
                    <el-input v-model="updateFieldForm.property" type="textarea" :rows="3"
                              placeholder='可选，JSON 对象，如 {"formatter":"0"} 或 {"options":[{"name":"选项1"}]}'/>
                </el-form-item>
                <el-form-item label="字段描述">
                    <el-input v-model="updateFieldForm.description" placeholder="可选，字段描述" clearable/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateFieldVisible = false">取 消</el-button>
                <el-button type="primary" :loading="updateFieldLoading" @click="handleUpdateField">更新字段</el-button>
            </span>
        </el-dialog>

        <!-- 信息表：本系统已创建的多维表格及其下数据表 -->
        <div class="cards-row info-row">

            <el-card class="info-card">
                <div slot="header" class="clearfix">
                    <span class="title">信息表（已创建的多维表格及数据表）</span>
                    <el-button
                        style="float: right;"
                        type="primary"
                        size="small"
                        :loading="infoLoading"
                        @click="loadBitableRecords"
                        icon="el-icon-refresh">刷新</el-button>
                </div>
                <div class="info-filter">
                    <el-input
                        v-model="infoFilter.app_token"
                        placeholder="按 App Token 精确过滤（可选）"
                        clearable
                        style="width: 320px; margin-right: 10px;"></el-input>
                    <el-button type="primary" size="small" :loading="infoLoading" @click="loadBitableRecords">查询</el-button>
                </div>
                <el-table :data="infoList" size="small" border style="width: 100%; margin-top: 10px;">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div class="sub-table-wrap">
                                <p class="result-title">该多维表格下的数据表（共 {{ (props.row.tables || []).length }} 张）</p>
                                <el-table :data="props.row.tables || []" size="mini" border>
                                    <el-table-column prop="table_id" label="table_id" min-width="180" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="table_name" label="表名称" min-width="160"></el-table-column>
                                    <el-table-column prop="default_view_id" label="默认视图 ID" min-width="180" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="created_at" label="创建时间" width="170"></el-table-column>
                                </el-table>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
                    <el-table-column prop="name" label="多维表格名称" min-width="150"></el-table-column>
                    <el-table-column prop="app_token" label="app_token" min-width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="default_table_id" label="默认表 ID" min-width="170" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="folder_token" label="文件夹 Token" min-width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="created_by" label="创建人ID" width="90" align="center"></el-table-column>
                    <el-table-column prop="created_at" label="创建时间" width="170"></el-table-column>
                </el-table>
                <div class="info-total">共 {{ infoTotal }} 个多维表格（信息表来自本系统创建时的落库记录）</div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import {
        feishuConfig,
        saveFeishuConfig,
        feishuTestConnection,
        feishuCreateBitable,
        feishuCreateTable,
        feishuBatchDeleteTables,
        feishuBatchDeleteRecords,
        feishuListTables,
        feishuListFields,
        feishuDeleteField,
        feishuCreateField,
        feishuUpdateField,
        feishuUpdateTable,
        feishuBatchCreateRecords,
        feishuBitableRecords
    } from '@/api/feishu'
    import { copyToClipboard } from '@/utils/security'

    const MASKED_SECRET = '******'

    export default {
        name: 'feishuSetting',
        data() {
            return {
                config: {},
                bitable: {
                    name: '',
                    folder_token: '',
                    time_zone: 'Asia/Shanghai',
                    fields: []
                },
                bitableResult: null,
                table: {
                    app_token: '',
                    name: '',
                    default_view_name: '',
                    fields: [],
                    recordsContent: ''
                },
                tableResult: null,
                records: {
                    app_token: '',
                    table_id: '',
                    content: ''
                },
                recordResult: null,
                deleteTables: {
                    app_token: '',
                    table_ids_text: ''
                },
                deleteResult: null,
                deleteRecords: {
                    app_token: '',
                    table_id: '',
                    records_text: ''
                },
                deleteRecordResult: null,
                listTables: {
                    app_token: ''
                },
                infoList: [],
                infoTotal: 0,
                infoLoading: false,
                infoFilter: {
                    app_token: ''
                },
                tableList: [],
                tableTotal: 0,
                updateTable: {
                    app_token: '',
                    table_id: '',
                    name: ''
                },
                updateResult: null,
                listFields: {
                    app_token: '',
                    table_id: ''
                },
                fieldList: [],
                fieldTotal: 0,
                loadingFields: false,
                createFieldVisible: false,
                createFieldLoading: false,
                createFieldForm: {
                    app_token: '',
                    table_id: '',
                    field_name: '',
                    type: 1,
                    ui_type: '',
                    property: '',
                    description: ''
                },
                updateFieldVisible: false,
                updateFieldLoading: false,
                updateFieldForm: {
                    field_id: '',
                    field_name: '',
                    type: 1,
                    ui_type: '',
                    property: '',
                    description: ''
                },
                loadingSave: false,
                loadingTest: false,
                loadingCreate: false,
                loadingTable: false,
                loadingRecord: false,
                loadingDelete: false,
                loadingDeleteRecord: false,
                loadingList: false,
                loadingUpdate: false,
                // 飞书官方字段类型枚举（与后端 FeishuBitable 保持一致）
                fieldTypes: [
                    { value: 1, label: '多行文本' },
                    { value: 2, label: '数字' },
                    { value: 3, label: '单选' },
                    { value: 4, label: '多选' },
                    { value: 5, label: '日期' },
                    { value: 7, label: '复选框' },
                    { value: 11, label: '人员' },
                    { value: 15, label: '超链接' },
                    { value: 17, label: '附件' }
                ]
            }
        },
        created() {
            this.getConfig()
            this.loadBitableRecords()
        },
        methods: {
            // 获取飞书配置
            getConfig() {
                feishuConfig().then(res => {
                    if (!res.success) {
                        return
                    }
                    this.config = res.data || {}
                })
            },
            // 保存配置
            saveConfigBtn() {
                const payload = { ...this.config }
                // app_secret 为脱敏占位或为空时，不向后端传值，避免覆盖已有密钥
                if (!payload.app_secret || payload.app_secret === MASKED_SECRET) {
                    delete payload.app_secret
                }
                this.loadingSave = true
                saveFeishuConfig(payload)
                    .then(res => {
                        this.loadingSave = false
                        if (!res.success) {
                            return
                        }
                        this.$message.success('保存成功')
                        this.getConfig()
                    })
                    .catch(() => {
                        this.loadingSave = false
                    })
            },
            // 测试连接
            testConnectionBtn() {
                this.loadingTest = true
                feishuTestConnection()
                    .then(res => {
                        this.loadingTest = false
                        if (!res.success) {
                            return
                        }
                        this.$message.success('飞书连接成功')
                    })
                    .catch(() => {
                        this.loadingTest = false
                    })
            },
            // 创建多维表格
            createBitableBtn() {
                const payload = {
                    name: this.bitable.name,
                    folder_token: this.bitable.folder_token,
                    time_zone: this.bitable.time_zone || 'Asia/Shanghai',
                    fields: this.bitable.fields.filter(item => item.field_name !== null && item.field_name !== '' && item.field_name !== undefined)
                }
                this.loadingCreate = true
                feishuCreateBitable(payload)
                    .then(res => {
                        this.loadingCreate = false
                        if (!res.success) {
                            return
                        }
                        this.bitableResult = res.data || {}
                        // 创建成功后自动填入记录的 app_token 与默认表 ID
                        this.records.app_token = this.bitableResult.app_token || ''
                        this.records.table_id = this.bitableResult.default_table_id || ''
                        this.table.app_token = this.bitableResult.app_token || ''
                        this.deleteTables.app_token = this.bitableResult.app_token || ''
                        this.deleteRecords.app_token = this.bitableResult.app_token || ''
                        this.deleteRecords.table_id = this.bitableResult.default_table_id || ''
                        this.listTables.app_token = this.bitableResult.app_token || ''
                        this.updateTable.app_token = this.bitableResult.app_token || ''
                        this.loadBitableRecords()
                        this.recordResult = null
                        this.tableResult = null
                        this.deleteResult = null
                        this.deleteRecordResult = null
                        this.$message.success('创建多维表格成功')
                    })
                    .catch(() => {
                        this.loadingCreate = false
                    })
            },
            addField() {
                this.bitable.fields.push({ field_name: '', type: 1 })
            },
            removeField(index) {
                this.bitable.fields.splice(index, 1)
            },
            // 新增数据表：添加/删除字段
            addTableField() {
                this.table.fields.push({ field_name: '', type: 1 })
            },
            removeTableField(index) {
                this.table.fields.splice(index, 1)
            },
            // 新增数据表
            createTableBtn() {
                if (!this.table.app_token) {
                    this.$message.warning('请填写 App Token')
                    return
                }
                const payload = {
                    app_token: this.table.app_token,
                    name: this.table.name,
                    default_view_name: this.table.default_view_name,
                    fields: this.table.fields.filter(item => item.field_name !== null && item.field_name !== '' && item.field_name !== undefined)
                }
                if (this.table.recordsContent) {
                    let parsed
                    try {
                        parsed = JSON.parse(this.table.recordsContent)
                    } catch (e) {
                        this.$message.error('初始记录不是合法 JSON，请检查格式')
                        return
                    }
                    if (!Array.isArray(parsed)) {
                        this.$message.error('初始记录需为 JSON 数组，如 [{"fields":{...}}]')
                        return
                    }
                    payload.records = parsed
                }
                this.loadingTable = true
                feishuCreateTable(payload)
                    .then(res => {
                        this.loadingTable = false
                        if (!res.success) {
                            return
                        }
                        this.tableResult = res.data || {}
                        this.$message.success('新增数据表成功')
                    })
                    .catch(() => {
                        this.loadingTable = false
                    })
            },
            // 填入示例记录
            insertRecordExample() {
                this.records.content = JSON.stringify([
                    { fields: { '订单号': 'AD0001', '金额': 100 } },
                    { fields: { '订单号': 'AD0002', '金额': 200 } }
                ], null, 2)
            },
            // 新增多条记录
            batchCreateRecordsBtn() {
                if (!this.records.app_token || !this.records.table_id) {
                    this.$message.warning('请填写 App Token 与表 ID')
                    return
                }
                let parsed
                try {
                    parsed = JSON.parse(this.records.content)
                } catch (e) {
                    this.$message.error('记录数据不是合法 JSON，请检查格式')
                    return
                }
                if (!Array.isArray(parsed)) {
                    this.$message.error('记录数据需为 JSON 数组，如 [{"fields":{...}}]')
                    return
                }
                this.loadingRecord = true
                feishuBatchCreateRecords({
                    app_token: this.records.app_token,
                    table_id: this.records.table_id,
                    records: parsed
                })
                    .then(res => {
                        this.loadingRecord = false
                        if (!res.success) {
                            return
                        }
                        this.recordResult = res.data || {}
                        this.$message.success('新增记录成功')
                    })
                    .catch(() => {
                        this.loadingRecord = false
                    })
            },
            // 删除多个数据表
            batchDeleteTablesBtn() {
                if (!this.deleteTables.app_token) {
                    this.$message.warning('请填写 App Token')
                    return
                }
                const tableIds = this.deleteTables.table_ids_text
                    .split(/[\n,;]+/)
                    .map(s => s.trim())
                    .filter(s => s)
                if (tableIds.length === 0) {
                    this.$message.warning('请填写至少一个表 ID')
                    return
                }
                this.loadingDelete = true
                feishuBatchDeleteTables({
                    app_token: this.deleteTables.app_token,
                    table_ids: tableIds
                })
                    .then(res => {
                        this.loadingDelete = false
                        if (!res.success) {
                            return
                        }
                        this.deleteResult = res.data || {}
                        this.$message.success('删除数据表成功')
                    })
                    .catch(() => {
                        this.loadingDelete = false
                    })
            },
            // 删除多条记录
            batchDeleteRecordsBtn() {
                if (!this.deleteRecords.app_token) {
                    this.$message.warning('请填写 App Token')
                    return
                }
                if (!this.deleteRecords.table_id) {
                    this.$message.warning('请填写表 ID（table_id）')
                    return
                }
                const records = this.deleteRecords.records_text
                    .split(/[\n,;]+/)
                    .map(s => s.trim())
                    .filter(s => s)
                if (records.length === 0) {
                    this.$message.warning('请填写至少一个记录 ID')
                    return
                }
                this.loadingDeleteRecord = true
                feishuBatchDeleteRecords({
                    app_token: this.deleteRecords.app_token,
                    table_id: this.deleteRecords.table_id,
                    records: records
                })
                    .then(res => {
                        this.loadingDeleteRecord = false
                        if (!res.success) {
                            return
                        }
                        this.deleteRecordResult = res.data || {}
                        this.$message.success('删除记录成功')
                    })
                    .catch(() => {
                        this.loadingDeleteRecord = false
                    })
            },
            // 列出数据表
            listTablesBtn() {
                if (!this.listTables.app_token) {
                    this.$message.warning('请填写 App Token')
                    return
                }
                this.loadingList = true
                feishuListTables({
                    app_token: this.listTables.app_token
                })
                    .then(res => {
                        this.loadingList = false
                        if (!res.success) {
                            return
                        }
                        const data = res.data || {}
                        this.tableList = data.items || []
                        this.tableTotal = data.total || this.tableList.length
                    })
                    .catch(() => {
                        this.loadingList = false
                    })
            },
            // 点击「列出数据表」结果行：填充「列出字段」的 App Token/table_id 并触发字段查询
            handleTableRowClick(row) {
                if (!row || !row.table_id) {
                    this.$message.warning('该行缺少 table_id')
                    return
                }
                this.listFields.app_token = this.listTables.app_token || ''
                this.listFields.table_id = row.table_id
                this.listFieldsBtn()
                this.scrollToFieldCard()
            },
            // 滚动到「列出字段」卡片
            scrollToFieldCard() {
                this.$nextTick(() => {
                    const card = this.$refs.fieldCard
                    if (card && card.$el && card.$el.scrollIntoView) {
                        card.$el.scrollIntoView({behavior: 'smooth', block: 'start'})
                    }
                })
            },
            // 列出字段
            listFieldsBtn() {
                if (!this.listFields.app_token) {
                    this.$message.warning('请填写 App Token')
                    return
                }
                if (!this.listFields.table_id) {
                    this.$message.warning('请填写表 ID（table_id）')
                    return
                }
                this.loadingFields = true
                feishuListFields({
                    app_token: this.listFields.app_token,
                    table_id: this.listFields.table_id
                })
                    .then(res => {
                        this.loadingFields = false
                        if (!res.success) {
                            return
                        }
                        const data = res.data || {}
                        this.fieldList = data.items || []
                        this.fieldTotal = data.total || this.fieldList.length
                    })
                    .catch(() => {
                        this.loadingFields = false
                    })
            },
            // 打开新增字段弹窗（预填当前查询的 App Token / 表 ID）
            openCreateFieldDialog() {
                this.createFieldForm.app_token = this.listFields.app_token || ''
                this.createFieldForm.table_id = this.listFields.table_id || ''
                this.createFieldVisible = true
            },
            // 新增字段
            handleCreateField() {
                if (!this.createFieldForm.app_token) {
                    this.$message.warning('请填写 App Token')
                    return
                }
                if (!this.createFieldForm.table_id) {
                    this.$message.warning('请填写表 ID（table_id）')
                    return
                }
                if (!this.createFieldForm.field_name) {
                    this.$message.warning('请填写字段名称')
                    return
                }
                const payload = {
                    app_token: this.createFieldForm.app_token,
                    table_id: this.createFieldForm.table_id,
                    field_name: this.createFieldForm.field_name,
                    type: this.createFieldForm.type
                }
                if (this.createFieldForm.ui_type) {
                    payload.ui_type = this.createFieldForm.ui_type
                }
                if (this.createFieldForm.property) {
                    let property = null
                    try {
                        property = JSON.parse(this.createFieldForm.property)
                    } catch (e) {
                        property = null
                    }
                    if (!property || typeof property !== 'object' || Array.isArray(property)) {
                        this.$message.error('字段属性需为合法的 JSON 对象')
                        return
                    }
                    payload.property = property
                }
                if (this.createFieldForm.description) {
                    payload.description = this.createFieldForm.description
                }
                this.createFieldLoading = true
                feishuCreateField(payload).then(res => {
                    this.createFieldLoading = false
                    if (!res.success) {
                        return
                    }
                    this.createFieldVisible = false
                    this.$message.success('新增字段成功')
                    // 同步查询条件并刷新字段列表
                    this.listFields.app_token = this.createFieldForm.app_token
                    this.listFields.table_id = this.createFieldForm.table_id
                    this.listFieldsBtn()
                }).catch(() => {
                    this.createFieldLoading = false
                })
            },
            // 打开更新字段弹窗（用字段查询结果行预填）
            openUpdateFieldDialog(row) {
                if (!row || !row.field_id) {
                    this.$message.warning('该行缺少 field_id')
                    return
                }
                if (!this.listFields.app_token || !this.listFields.table_id) {
                    this.$message.warning('请先查询字段（缺少 App Token / 表 ID）')
                    return
                }
                this.updateFieldForm.field_id = row.field_id
                this.updateFieldForm.field_name = row.field_name || ''
                this.updateFieldForm.type = Number(row.type) || 1
                this.updateFieldForm.ui_type = row.ui_type || ''
                this.updateFieldForm.property = row.property ? JSON.stringify(row.property) : ''
                this.updateFieldForm.description = (row.description && row.description.text) ? row.description.text : ''
                this.updateFieldVisible = true
            },
            // 更新字段
            handleUpdateField() {
                if (!this.updateFieldForm.field_id) {
                    this.$message.warning('缺少 field_id')
                    return
                }
                if (!this.updateFieldForm.field_name) {
                    this.$message.warning('请填写字段名称')
                    return
                }
                if (!this.listFields.app_token || !this.listFields.table_id) {
                    this.$message.warning('请先查询字段（缺少 App Token / 表 ID）')
                    return
                }
                const payload = {
                    app_token: this.listFields.app_token,
                    table_id: this.listFields.table_id,
                    field_id: this.updateFieldForm.field_id,
                    field_name: this.updateFieldForm.field_name,
                    type: this.updateFieldForm.type
                }
                if (this.updateFieldForm.ui_type) {
                    payload.ui_type = this.updateFieldForm.ui_type
                }
                if (this.updateFieldForm.property) {
                    let property = null
                    try {
                        property = JSON.parse(this.updateFieldForm.property)
                    } catch (e) {
                        property = null
                    }
                    if (!property || typeof property !== 'object' || Array.isArray(property)) {
                        this.$message.error('字段属性需为合法的 JSON 对象')
                        return
                    }
                    payload.property = property
                }
                if (this.updateFieldForm.description) {
                    payload.description = this.updateFieldForm.description
                }
                this.updateFieldLoading = true
                feishuUpdateField(payload).then(res => {
                    this.updateFieldLoading = false
                    if (!res.success) {
                        return
                    }
                    this.updateFieldVisible = false
                    this.$message.success('更新字段成功')
                    this.listFieldsBtn()
                }).catch(() => {
                    this.updateFieldLoading = false
                })
            },
            // 删除字段
            deleteFieldBtn(row) {
                if (!this.listFields.app_token || !this.listFields.table_id) {
                    this.$message.warning('请先填写 App Token 与表 ID（table_id）')
                    return
                }
                if (!row || !row.field_id) {
                    this.$message.warning('缺少 field_id，无法删除')
                    return
                }
                this.$confirm(`确定删除字段「${row.field_name || row.field_id}」（${row.field_id}）？删除后不可恢复。`, '删除字段', {
                    type: 'warning'
                }).then(() => {
                    this.loadingFields = true
                    feishuDeleteField({
                        app_token: this.listFields.app_token,
                        table_id: this.listFields.table_id,
                        field_id: row.field_id
                    })
                        .then(res => {
                            this.loadingFields = false
                            if (!res.success) {
                                return
                            }
                            this.$message.success('删除字段成功')
                            this.listFieldsBtn()
                        })
                        .catch(() => {
                            this.loadingFields = false
                        })
                }).catch(() => {
                })
            },
            // 字段类型数字转中文标签
            fieldTypeLabel(type) {
                const t = Number(type)
                const found = this.fieldTypes.find(item => item.value === t)
                return found ? found.label : String(type)
            },
            // 更新数据表

            // 更新数据表
            updateTableBtn() {
                if (!this.updateTable.app_token) {
                    this.$message.warning('请填写 App Token')
                    return
                }
                if (!this.updateTable.table_id) {
                    this.$message.warning('请填写表 ID（table_id）')
                    return
                }
                if (!this.updateTable.name) {
                    this.$message.warning('请填写新的表名称')
                    return
                }
                this.loadingUpdate = true
                feishuUpdateTable({
                    app_token: this.updateTable.app_token,
                    table_id: this.updateTable.table_id,
                    name: this.updateTable.name
                })
                    .then(res => {
                        this.loadingUpdate = false
                        if (!res.success) {
                            return
                        }
                        this.updateResult = res.data || {}
                        this.$message.success('更新数据表成功')
                    })
                    .catch(() => {
                        this.loadingUpdate = false
                    })
            },
            // 查询已创建的多维表格信息表（含其下数据表）
            loadBitableRecords() {
                this.infoLoading = true
                feishuBitableRecords({
                    app_token: this.infoFilter.app_token
                })
                    .then(res => {
                        this.infoLoading = false
                        if (!res.success) {
                            return
                        }
                        const data = res.data || {}
                        this.infoList = data.list || []
                        this.infoTotal = data.total || 0
                    })
                    .catch(() => {
                        this.infoLoading = false
                    })
            },
            // 新增数据表：把当前自定义字段批量复制为 JSON 到剪贴板
            copyTableFieldsToJson() {
                const rows = (this.table.fields || [])
                    .filter(item => item.field_name !== null && item.field_name !== '' && item.field_name !== undefined)
                    .map(item => ({
                        field_name: item.field_name,
                        type: item.type || 1
                    }))
                if (!rows.length) {
                    this.$message.warning('暂无自定义字段可复制')
                    return
                }
                copyToClipboard(JSON.stringify(rows)).then(() => {
                    this.$message.success(`已复制 ${rows.length} 个字段的 JSON 到剪贴板`)
                })
            },
            // 点击复制文本
            copy(item) {
                if (!item) {
                    return
                }
                const cInput = document.createElement('input')
                cInput.value = item
                document.body.appendChild(cInput)
                cInput.select()
                document.execCommand('copy')
                this.$message({ type: 'success', message: '复制成功' })
                document.body.removeChild(cInput)
            }
        }
    }
</script>

<style scoped>
    .feishu-container {
        margin-top: 20px;
        margin-left: 20px;
    }
    .cards-row {
        display: flex;
        align-items: flex-start;
    }
    .config-card {
        width: 720px;
        margin-right: 50px;
    }
    .bitable-card {
        width: 720px;
    }
    .second-row {
        margin-top: 30px;
    }
    .third-row {
        margin-top: 30px;
    }
    .table-card {
        width: 720px;
        margin-right: 50px;
    }
    .records-card {
        width: 720px;
    }
    .delete-card {
        width: 720px;
        margin-right: 50px;
    }
    .delete-record-card {
        width: 720px;
    }
    .fourth-row {
        margin-top: 30px;
    }
    .list-card {
        width: 720px;
        margin-right: 50px;
    }
    .update-card {
        width: 720px;
    }
    .update-card {
        width: 720px;
    }
    .fifth-row {
        margin-top: 30px;
    }
    .field-card {
        width: 720px;
    }
    .info-row {
      .info-row {
        margin-top: 30px;
      }

      .info-card {
        width: 1490px;
      }

      .info-filter {
        display: flex;
        align-items: center;
      }

      .sub-table-wrap {
        padding: 10px;
      }

      .sub-table-wrap .result-title {
        font-weight: bold;
        margin-bottom: 8px;
      }

      .info-total {
        margin-top: 12px;
        color: #909399;
        font-size: 13px;
      }

      .title {
        font-size: 18px;
        line-height: 32px;
      }

      .field-row {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
      }

      .field-name {
        width: 220px;
        margin-right: 10px;
      }

      .field-type {
        width: 150px;
        margin-right: 10px;
      }

      .bitable-result {
        margin-top: 12px;
        padding: 12px;
        background: #f5f7fa;
        border-radius: 4px;
        line-height: 26px;
      }

      .bitable-result .result-title {
        font-weight: bold;
      }

      .bitable-result .value {
        cursor: pointer;
        color: #409eff;
        word-break: break-all;
      }
    }
</style>


